import React from 'react';
import '../style/DeleteConfirmModal.css';

const DeleteConfirmModal = ({ onConfirm, onClose }) => {
    return (
        <div className="modal">
            <div className="modal-content">
                <h2>Удалить памятку?</h2>
                <p>Вы уверены, что хотите удалить эту памятку?</p>
                <button className="confirm-button" onClick={onConfirm}>Удалить</button>
                <button className="cancel-button" onClick={onClose}>Отмена</button>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
